import React from "react";
import { Link } from "react-router-dom";
import "./Products.css";

const productCategories = [
  {
    name: "Inverter Batteries",
    slug: "inverter-batteries",
    ranges: ["120Ah", "150Ah", "180Ah", "200Ah", "220Ah"],
    description: "Enduring power for every home.",
    image: "p1.jpg",
  },
  {
    name: "E-Rickshaw Batteries",
    slug: "e-rickshaw-batteries",
    ranges: ["120Ah", "130Ah", "140Ah"],
    description: "Mobility with strength.",
    image: "p2.jpg",
  },
  {
    name: "Solar Batteries",
    slug: "solar-batteries",
    ranges: ["20Ah", "40Ah", "60Ah", "75Ah"],
    description: "Energy from the sun.",
    image: "p3.jpg",
  },
  {
    name: "Tractor Batteries",
    slug: "tractor-batteries",
    ranges: ["88Ah", "100Ah", "120Ah", "150Ah"],
    description: "Built for the toughest fields.",
    image: "p4.jpg",
  },
  {
    name: "Automotive Batteries",
    slug: "automotive-batteries",
    ranges: ["35Ah", "50Ah", "60Ah", "70Ah", "80Ah", "90Ah", "100Ah", "120Ah"],
    description: "Precision power for every vehicle.",
    image: "p5.jpg",
  },
];

function ProductCard({ category }) {
  return (
    <Link to={`/category/${category.slug}`} className="product-card">
      <div className="product-image-wrapper">
        <img
          src={category.image}
          alt={category.name}
          className="product-image"
        />
      </div>
      <div className="product-body">
        <div>
          <h3 className="product-name">{category.name}</h3>
          <p className="product-description">{category.description}</p>
        </div>
        <div className="product-ranges">
          {category.ranges.slice(0, 4).map((range, idx) => (
            <span key={idx} className="range-tag">{range}</span>
          ))}
          {category.ranges.length > 4 && (
            <span className="range-more">+{category.ranges.length - 4} more</span>
          )}
        </div>
        <div className="product-cta">
          <span>View Range</span>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </div>
      </div>
    </Link>
  );
}

function Products() {
  return (
    <section className="products">
      <div className="products-container">
        <div className="products-header">
          <span className="products-eyebrow">What We Offer</span>
          <h2 className="products-title">
            Our <span className="products-title-accent">Battery</span> Range
          </h2>
          <p className="products-subtitle">
            Five categories. Every application. One trusted name.
          </p>
        </div>
        <div className="products-grid">
          {productCategories.map((category, index) => (
            <ProductCard key={index} category={category} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Products;
